const PIECE_ASSET_VERSION =
  process.env.NEXT_PUBLIC_PIECE_ASSET_VERSION || "2026-03-21";

export function getPieceImageUrl(chessSet: string, piece: string): string {
  const pieceFile = piece.endsWith(".svg") ? piece : `${piece}.svg`;
  return `/images/pieces/${chessSet}/${pieceFile}?v=${encodeURIComponent(
    PIECE_ASSET_VERSION
  )}`;
}
